module.exports = __webpack_public_path__ + "static/media/image-gallery-5.6c3c0f94.jpg";